import { useState, useEffect } from "react";
import { useGlobalContext } from "../GlobalContext";
import TransaksiHarirayapdf from "./report/pdf/transaksihariraya";

const TransaksiHariRaya = () => {
    const tglSekarang = new Date().toISOString().split("T")[0];
    const { periode,kode } = useGlobalContext();
  	const { api } = useGlobalContext();

    const [formData, setFormData] = useState({
        noTransaksi: "",
        tglTransak: tglSekarang,
        noAnggota: "",
        nama: "",
        unitkerja: "",
        saldoAwl: 0,
        jenisTransaksi: "1",
        jumlah: 0,
        saldoAkhir: 0,
        kduser: kode,
        notransumum:"-",
    });	

    const handleReset = () => {
        setFormData({
            noTransaksi: "",
            tglTransak: tglSekarang,
            noAnggota: "",
            nama: "",
            unitkerja: "",
            saldoAwl: 0,
            jenisTransaksi: "1",
            jumlah: 0,
            saldoAkhir: 0,
        });
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: name === "jumlah" || name === "saldoAwl" ? Number(value) || 0 : value
        }));
    };

     // Fungsi untuk memformat angka ke format ribuan dengan titik
     const formatNumber = (value) => {
        return new Intl.NumberFormat("id-ID").format(value);
    };

    // Fungsi untuk mengubah format angka ke tipe number
    const parseNumber = (value) => {
        return Number(value.replace(/\./g, "")) || 0;
    };

    // Fungsi untuk menangani perubahan input
    const handleInputChange2 = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: name === "jumlah" || name === "saldoAwl" ? parseNumber(value) : value
        }));
    };

    const GenereateNoTrans = async () => {
    const noawal = periode.toString();
    const notransaksiwal = noawal.substring(2, 6); // 4 digit awal

    try {
        const response = await api.get(`/api/transaksi/getnotransaksihariraya/${notransaksiwal}`);
        if (response.status === 200 && response.data.notransaksi) {
        const lastNo = response.data.notransaksi.toString();
        const lastIndex = parseInt(lastNo.substring(4, 10)) || 0; // ambil 6 digit terakhir
        const nextIndex = lastIndex + 1;

        const notransaksi = notransaksiwal + nextIndex.toString().padStart(6, "0"); // total 10 digit

        setFormData((prevData) => ({
            ...prevData,
            noTransaksi: notransaksi,
        }));
        } else {
        // kalau belum ada data, mulai dari 000001
        setFormData((prevData) => ({
            ...prevData,
            noTransaksi: notransaksiwal + "000001",
        }));
        }
    } catch (error) {
        // fallback kalau error
        setFormData((prevData) => ({
        ...prevData,
        noTransaksi: notransaksiwal + "000001",
        }));
    }
    };

    useEffect(() => {
    if (periode) {
        GenereateNoTrans();
    }
    }, [periode]);

    useEffect(() => {
        setFormData((prev) => ({
            ...prev,
            saldoAkhir: prev.jenisTransaksi === "1"
                ? Number(prev.saldoAwl) + Number(prev.jumlah)
                : Number(prev.saldoAwl) - Number(prev.jumlah)
        }));
    }, [formData.jumlah, formData.jenisTransaksi, formData.saldoAwl]);

    const handleBlur = async () => {
        if (!formData.noAnggota) return; // Cegah permintaan kosong
    
        try {
      const response = await api.get(`/api/anggota/${formData.noAnggota}`);
    
            if (response.data) {
                setFormData((prev) => ({
                    ...prev,
                    nama: response.data.nama,         // Isi nama dari API
                    unitkerja: response.data.unitkerja, // Isi unit kerja dari API
                    saldoAwl: Number(response.data.saldoakh) || 0  // Isi saldo awal dari API
                }));
            } else {
                throw new Error("Data anggota tidak ditemukan");
            }
    
            const response2 = await api.get(`/api/transaksi/saldosimphariraya/${periode}/${formData.noAnggota}`);
    
            if (response2.data) {
                setFormData((prev) => ({
                    ...prev,
                    saldoAwl: Number(response2.data.saldoakh) || 0
                }));
            }
        } catch (error) {
            alert("Data anggota tidak ditemukan! Silakan masukkan nomor anggota yang benar.");
            
            // Reset form kecuali noAnggota
            setFormData((prev) => ({
                ...prev,
                nama: "",
                unitkerja: "",
                saldoAwl: 0,
                saldoAkhir: 0,
                jumlah: 0
            }));
        }
    };    

    const handleSubmit = async () => {
        const tanggal = new Date(formData.tglTransak);
        const yyyymm = `${String(tanggal.getFullYear())}${String(tanggal.getMonth() + 1).padStart(2, "0")}`;
        if (yyyymm !== periode) {
            alert(`Tanggal transaksi tidak sesuai dengan periode`);      
            handleReset();
            return;
        }
        const datasimpan = {
            notransaksi: formData.noTransaksi || "",
            tgltransak: formData.tglTransak || "",
            noanggota: formData.noAnggota || "",
            kdtrans: formData.jenisTransaksi || "1",
            debet: formData.jenisTransaksi === "2" ? `${formData.jumlah}` : "0",
            kredit: formData.jenisTransaksi === "1" ? `${formData.jumlah}` : "0",
            saldoawl: `${formData.saldoAwl}` || 0,
            saldo: `${formData.saldoAkhir}` || 0,       
            kduser:kode,
            notransumum:"-"     
        };        
        try {
            const response = await api.post("/api/transaksi/simpananhariraya", datasimpan);            
            if (response.status === 201) {
                alert("Data berhasil disimpan!");
                const data = await fetchTransaksiHariraya(`${formData.noTransaksi}`);
                if (data) {
                    TransaksiHarirayapdf(data);
                }
                handleReset(); // reset form
            } else {
                alert(`Gagal menyimpan data. Status: ${response.status}`);
            }
        } catch (error) {
            alert("Gagal menyimpan data.");
        }
    };

    const fetchTransaksiHariraya = async (notransaksi) => {
        if (!notransaksi) {
          alert("No Transaksi masih kosong.");
          return null;
        }
        try {
          const response = await api.get(`/api/transaksi/gettransaksihariraya/${notransaksi}`);
    
          if (!response.data || response.data.length === 0) {
            alert("Tidak ada data transaksi Hariraya untuk dicetak.");
            return null;
          }
      
          return response.data;
        } catch (error) {
          alert("Gagal mengambil data transaksi Hariraya.");
          return null;
        }
      };

    return (
        <div className="container mt-5 d-flex justify-content-center align-items-center">
            <div className="card card-info" style={{ width: "570px" }}>
                <div className="card-header">
                    <h3 className="card-title">Transaksi Hari Raya</h3>
                </div>
                <div className="card-body">
                <div className="form-group row">
            <label className="col-sm-3 col-form-label">No. Transaksi</label>
            <div className="col-sm-3">
            <input
                type="text"
                className="form-control"
                name="noTransaksi"
                value={formData.noTransaksi}
                onChange={handleInputChange}
                readOnly
              />
            </div>
            <div className="col-auto">
                            <button className="btn btn-primary" style={{ backgroundColor: "blue", color: "white" }} onClick={GenereateNoTrans}>Click</button>
                        </div>
          </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Tanggal</label>
                        <div className="col-sm-4">
                            <input type="date" className="form-control" name="tglTransak" value={formData.tglTransak} onChange={handleInputChange} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">No. Anggota</label>
                        <div className="col-sm-4">
                            <input
                                type="text"
                                className="form-control"
                                name="noAnggota"
                                value={formData.noAnggota}
                                onBlur={handleBlur}
                                onChange={handleInputChange}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Nama</label>
                        <div className="col-sm-7">
                            <input
                                type="text"
                                className="form-control"
                                name="nama"
                                value={formData.nama}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Unit Kerja</label>
                        <div className="col-sm-7">
                            <input
                                type="text"
                                className="form-control"
                                name="unitkerja"
                                value={formData.unitkerja}
                                readOnly
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Saldo Awal</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" name="saldoAwl" value={formatNumber(formData.saldoAwl)}  style={{ textAlign: "right" }} readOnly />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Jenis Transaksi</label>
                        <div className="col-sm-4">
                            <select className="form-control" name="jenisTransaksi" value={formData.jenisTransaksi} onChange={handleInputChange}>
                                <option value="">Pilih Jenis Transaksi</option>
                                <option value="1">Setoran</option>
                                <option value="2">Penarikan</option>
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Jumlah</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" name="jumlah" value={formatNumber(formData.jumlah)} onChange={handleInputChange2}  style={{ textAlign: "right" }} />
                        </div>
                    </div>
                    <div className="form-group row">
                        <label className="col-sm-3 col-form-label">Saldo Akhir</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" name="saldoAkhir" value={formatNumber(formData.saldoAkhir)}  style={{ textAlign: "right" }} readOnly />
                        </div>
                    </div>
                    <div className="modal-footer">
                    <button className="btn btn-secondary" onClick={handleReset}>Batal</button>
                        <button className="btn btn-primary" onClick={handleSubmit}>Simpan</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransaksiHariRaya;
